<ifc-app-scroll-container [widgetsWithTopHeader]="true">
  <div [@routerTransition]="'fly'">
    <div class="container">
      <div class="column">
        <ifb-new-draws-card-chart></ifb-new-draws-card-chart>
        <ifb-total-draws-card-chart></ifb-total-draws-card-chart>
        <ifb-product-averages-list></ifb-product-averages-list>
      </div>

      <div class="column">
        <ifb-residual-draws-card-chart></ifb-residual-draws-card-chart>
        <ifb-card>
          <ifc-simple-horizontal-list-widget title="Account onboarding (current stage)"
                                             [listItems]="accountOnboardingListData">
          </ifc-simple-horizontal-list-widget>
        </ifb-card>
        <ifb-card>
          <ifc-simple-horizontal-list-widget title="Account breakdown"
                                             [listItems]="accountBreakdownListData">
          </ifc-simple-horizontal-list-widget>
        </ifb-card>
      </div>

      <div class="column">
        <ifb-draws-leaderboard-list></ifb-draws-leaderboard-list>
        <ifb-account-onboarding-chart></ifb-account-onboarding-chart>
      </div>
    </div>
  </div>
</ifc-app-scroll-container>
